import { render } from "./DependientesTable.vue?vue&type=template&id=8966730c"
import script from "./DependientesTable.vue?vue&type=script&lang=js"
export * from "./DependientesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__